"use client"
import { GetPageQuery } from "apollo"
import { BlockRenderer } from "ui"
import { Culture, findProperty } from "utils"
import BonitaContactForm from "./ContactUs/BonitaContactForm"
import BonitaContactInfo from "./ContactUs/BonitaContactInfo"
import BonitaProjects from "./ContactUs/BonitaProjects"

type Props = {
  data: GetPageQuery
  culture: Culture
  locale: string
  companyId?: number
}

function ContactUs({ data, culture, locale, companyId }: Props) {
  const components = {
    tierraBonitaContactForm: BonitaContactForm,
    tierraBonitaContactInfo: BonitaContactInfo,
    tierraBonitaProjects: BonitaProjects,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []
  return (
    <>
      {blocks?.map(
        // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
        (block: any, index: number) => {
          let additionalProps = {}
          if (block.blockType === "tierraBonitaContactForm") {
            additionalProps = {
              companyId,
            }
          }
          return (
            <BlockRenderer
              key={index}
              blockType={block.blockType}
              blockData={block}
              components={components}
              culture={culture}
              locale={locale}
              props={additionalProps}
            />
          )
        },
      )}
    </>
  )
}

export default ContactUs
